import { LitElement, html, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import { oneOfStringsAttributeSchema } from './helpers/yup'
import type { RotatingChevronAttributes } from 'zaptic-rotating-chevron'
import type * as yup from 'yup'

type Direction = RotatingChevronAttributes['direction']

// 'up-alt' rotates the chevron in the opposite direction to 'up'
const directionAttributeSchema = oneOfStringsAttributeSchema(
    'up',
    'down',
    'right',
    'left',
    'up-alt'
) as yup.Schema<Direction>

const convertDirectionAttributeToProperty = (value: unknown): Direction | null => {
    try {
        return directionAttributeSchema.validateSync(value)
    } catch (ignore) {
        return null
    }
}

@customElement('zaptic-rotating-chevron')
export class RotatingChevron extends LitElement implements RotatingChevronAttributes {
    static styles = css`
        :host {
            display: block;
        }

        :host([hidden='true']) {
            display: none;
        }

        svg {
            transition: transform 300ms ease-in-out;
            width: var(--RotatingChevron-size, 1.6rem);
            height: var(--RotatingChevron-size, 1.6rem);
            color: var(--RotatingChevron-color, var(--grey-600, #4f5b68));
            transform-origin: center center;
        }

        .up svg {
            transform: rotate(-180deg);
        }

        .up-alt svg {
            transform: rotate(180deg);
        }

        .right svg {
            transform: rotate(-90deg);
        }

        .left svg {
            transform: rotate(90deg);
        }
    `

    @property({
        reflect: true,
        type: String,
        converter: convertDirectionAttributeToProperty,
    })
    direction: Direction = 'down'

    render() {
        return html`<span data-testid="chevron" class="${this.direction}"
            ><zaptic-icon icon-name="chevron-down"></zaptic-icon
        ></span>`
    }
}
